import {Collection} from "@aws-amplify/ui-react"
import {CollectionType} from "@aws-amplify/ui-react/dist/types/primitives/types/collection"
import navItems from "components/layout/MenuItems/navItems.json"
import MenuItem from "./MenuItem"


export default function MenuItems({
    type = "grid",
    direction = "column"
}: {
    type?: CollectionType & "list",
    direction?: string
}) {
    return <Collection
        type={ type }
        direction={ direction }
        templateColumns="1fr 1fr"
        columnGap="1rem"
        autoFlow="row"
        alignItems="stretch"
        justifyContent="flex-start"
        items={ navItems }
    >
        { (menuItem, index) => (
            <MenuItem
                key={ menuItem.id }
                state={ type === "grid"
                    ? "Arrow"
                    : "Unselected" }
                title={ menuItem.title }
                path={ menuItem.path }
            />
        ) }
    </Collection>
}
